import { IconButton, Slide, Snackbar } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../store';
import { clearToast } from './toastSlice';
import { SyntheticEvent, useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/CloseTwoTone';
import { Progress as ToastProgress, Success as ToastSuccess } from './';
import classNames from 'classnames/bind';

import styles from './Toast.module.css';
const classNamesCtx = classNames.bind(styles);

/**
 * Component handling the rendering of toast popup message components in the layout
 */
export default function Toaster() {
	const appDispatch = useAppDispatch();
	const toastMessages = useAppSelector((state) => state.toastState.messages);
	const [isOpen, setIsOpen] = useState(false);

	useEffect(() => {
		if (toastMessages.length > 0) {
			setIsOpen(true);
		}
	}, [toastMessages]);

	/**
	 * Method executed to close the toast
	 */
	const handleClose = (_: Event | SyntheticEvent, reason?: string) => {
		if (reason !== 'clickaway') {
			setIsOpen(false);
		}
	};

	/**
	 * Method executed upon the transition completing
	 */
	const handleTransitionExit = () => {
		appDispatch(clearToast(toastMessages[0].id));
	};

	if (toastMessages.length < 1) {
		return <></>;
	}

	const closeBtnClass = classNamesCtx({
		hidden: toastMessages[0].type === 'progress'
	});

	const ToastMessage = () => {
		switch (toastMessages[0].type) {
			case 'progress': {
				return (
					<ToastProgress
						toastId={toastMessages[0].id}
						message={toastMessages[0].message}
						total={toastMessages[0].total}
					/>
				);
			}

			case 'success': {
				return (
					<ToastSuccess
						message={toastMessages[0].message}
						successCount={toastMessages[0].successCount}
						errorCount={toastMessages[0].errorCount}
					/>
				);
			}

			default: {
				return toastMessages[0].message;
			}
		}
	};

	return (
		<Snackbar
			key={`toast-${String(toastMessages[0].id)}`}
			className={styles.toast}
			slots={{
				transition: Slide
			}}
			slotProps={{
				content: {
					className: `${styles.butter} ${toastMessages[0].severity ? styles[toastMessages[0].severity] : ''}`
				},
				transition: { onExited: handleTransitionExit }
			}}
			open={isOpen}
			onClose={handleClose}
			autoHideDuration={toastMessages[0].autoCloseMs}
			message={<ToastMessage />}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'right'
			}}
			action={
				<IconButton
					aria-label='close'
					color='inherit'
					onClick={handleClose}
					className={closeBtnClass}
				>
					<CloseIcon />
				</IconButton>
			}
			sx={{
				'& .MuiSnackbarContent-message': {
					flexGrow: 1
				}
			}}
		/>
	);
}
